import { useTranslation } from '@frontend/i18n';
import { FormFieldActionTypes, useForm } from '@frontend/design-system';
import { ForwardingNumberPicker } from '../../forwarding-number-picker';
import { DialOptionInstruction } from '../types';
import { ReadOnlyInstructionField } from './read-only-instruction';
import { InstructionFieldStyles } from './styles';

export const ForwardNumberInstructionFields = ({
  onChange,
  instructionState,
  locationId,
  disabled = false,
  isReadOnly = false,
}: {
  onChange: (payload: DialOptionInstruction) => void;
  instructionState: DialOptionInstruction;
  locationId: string;
  disabled?: boolean;
  isReadOnly?: boolean;
}) => {
  const { t } = useTranslation('phone');

  const form = useForm({
    fields: {
      forwardingNumberId: {
        type: 'dropdown',
        value: instructionState.id,
      },
    },
    fieldStateReducer: (state, action) => {
      // When any field is updated, extract all field values and notify the parent component
      if (action.type === FormFieldActionTypes.Update) {
        const payload = {
          ...instructionState,
          id: state.forwardingNumberId.value,
        };
        onChange(payload);
      }

      return state;
    },
  });

  if (isReadOnly) {
    return (
      <ReadOnlyInstructionField
        instructionName={instructionState.name ?? t('Unknown Forwarding Number')}
        iconName={'send-forward'}
        instructionType={t('Forwarding Number')}
      />
    );
  }

  return (
    <ForwardingNumberPicker
      {...form.getFieldProps('forwardingNumberId')}
      locationId={locationId}
      disabled={disabled}
      css={InstructionFieldStyles}
    />
  );
};
